window.MESSAGE_GATEWAY_CONFIG = {
  env: 'uat',
  hosts: {
    // cbBaseUrl: 'https://apiuat.opap.systems/content-builder',
    cbBaseUrl: 'http://localhost:8889/content-builder',
  },
  // cbVarible:
  //   'zJ9JwJ4mPrMYgOnQTzLhBMLrVRaTz6m5J73Kmz9xoibgfh8nrFoInGS5PxbRyoaRTpS1nnljCusFT2o9NVqywIH3p8Jcawz0sqAET1j4cbu3IXd9PT8zgokwkjV5UyPx',
  cbVarible:
    'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.e30.TGpzKORDy8VSHTYqrV1ld2zcPsfHmlyZWuOy63F5h-PKmVMm2IbIvJdxJc701h7FiXFwQc4MFACX-LU8sq9lAg',
  varible:
    'ADKLdQ9mT6UnhznSnaBkQdX7Jn3Af9XBnuJmVQ6HNx34NHztCZP3QM4HDmf8ZeucMrAH8eqMfvE3Ys657HeXnX5CMZcMLVKQn5SeXLFcmbThCRLE6Gn3AKu7kqJrAbQA',
  tzokerDC: 'ONL_UAT_TZ_D',
  cbmDC: 'ONL_UAT_DWH_CUSTOMER_PROFILE',
  casDC: 'CBM_ONL_UAT_CAS_PROGRAM_INFO',
  crmDC: 'ONL_UAT_CRM_CUSTOMER_PROFILE',
  additionalDC: 'ONL_UAT_ADDITIONAL_FLAGS',
  publishURL: 'https://staticassetsuat.pamestoixima.gr/custom-activity/publish/',
  retailDELOYFlags: 'LOY_FLAGS',
  loyCustomersProfile: 'LOY_CUSTOMERS_PROFILE',
  vltDEDaily: 'VLTS_DAILY_PLR',
  vltDEAdhoc: 'VLTS_ADHOC_DATA',
  vltCommonDC: 'VLTS_CRM_CUSTOMER_PROFILE',
  apiURL: 'https://apiuat.opap.systems/messaging/submission',
  pushApiURL: 'https://apiuat.opap.systems/messaging/push/submission',
  interstitialApiURL: '',
  interstitialVarible: '',
  viberApiURL: 'https://apiuat.opap.systems/messaging/viber/submission',
  enabledAppModules: {
    SMS: true,
    WEB_PUSH: true,
    INTERSTITIAL: true,
    NATIVE_PUSH: true,
    VIBER: true,
    IN_APP: true,
  },
  shortUrlBaseHostName: 'dev.opap.ly',
};
